/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WelcomeScreensUpdatePathParams,
	WelcomeScreensUpdateRequest,
	WelcomeScreensUpdateResponse,
} from '../types/WelcomeScreensUpdate'

/**
 * PUT /welcome-screens/:welcomeScreen
 * @see backend/nexus/modules/Form/Http/Controllers/WelcomeScreenController.php WelcomeScreenController::update
 */
export async function welcomeScreensUpdate(
	welcomeScreen: WelcomeScreensUpdatePathParams['welcomeScreen'],
	data: WelcomeScreensUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WelcomeScreensUpdateResponse>> {
	return axiosInstance.put(`/welcome-screens/${welcomeScreen}`, data, config)
}
